import {
  call, put, takeEvery, takeLatest, select,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import selectors from '@/selectors';
import findResult from '@/utils/resultsHelper';
import { addWorkspaceRequestFieldsToSections } from '../state/state';
import WorkspacesService from '../service';
import {
  requestWorkspaceError,
  requestWorkspaceSuccess,
  showWorkspaceForm,
  showWorkspaceFormError,
  showWorkspaceFormHealthError,
  showWorkspaceFormHealthSuccess,
  showWorkspaceLocations,
  showWorkspaceLocationsError,
} from '../actions';
import actions, { workspaceActions, workspaceFormActions } from '../constants';

export function* workspacesLocations({ category }) {
  const { response, error } = yield call(callAdapter, WorkspacesService.workspacesLocations());
  if (error) {
    yield put(showWorkspaceLocationsError(category, error));
  } else {
    yield put(showWorkspaceLocations(category, response.items));
  }
}

export function* workspacesForm({ category, code, intl }) {
  const { response, error } = yield call(callAdapter, WorkspacesService.workspacesForm(code));
  if (error) {
    yield put(showWorkspaceFormError(category, code, error));
  } else {
    addWorkspaceRequestFieldsToSections(response, intl);
    yield put(showWorkspaceForm(category, code, response));
  }
}

export function* workspacesFormHealthCheck({ code, source }) {
  const { error } = yield call(callAdapter, WorkspacesService.workspacesFormHealthCheck(code));
  if (error) {
    yield put(showWorkspaceFormHealthError(code, source));
  } else {
    yield put(showWorkspaceFormHealthSuccess(code));
  }
}

export function* create({ code }) {
  const items = yield select(selectors.requests);
  const item = findResult(items, 'workspaces', code);
  const { response, error } = yield call(callAdapter, WorkspacesService.create(item));

  if (error) {
    yield put(requestWorkspaceError(code, error));
  } else {
    yield put(requestWorkspaceSuccess(code, response));
  }
}

export default function* workspacesApi() {
  yield takeEvery(actions.FETCH_WORKSPACE_LOCATIONS, workspacesLocations);
  yield takeLatest(workspaceFormActions.FETCH_WORKSPACE_FORM, workspacesForm);
  yield takeLatest(workspaceFormActions.HEALTH_WORKSPACE_FORM, workspacesFormHealthCheck);
  yield takeEvery(workspaceActions.REQUEST_WORKSPACE, create);
}
